var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.79,
    height: 20,
    viewBox: "0 0 10.79 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-367.736 -297.529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M370.746,308.818h-.464c-.668,0-1.336,0-2,0-.4,0-.532-.121-.535-.5q-.015-1.539,0-3.079c0-.38.144-.5.538-.5.725,0,1.45,0,2.175,0h.29c0-.12,0-.215,0-.31.017-.928-.017-1.86.062-2.782a4.394,4.394,0,0,1,4.316-4.092c.976-.037,1.955-.015,2.932-.013.324,0,.463.14.465.464q.008,1.454,0,2.908c0,.33-.137.461-.49.47-.659.016-1.319.016-1.979.026-.766.011-1.068.3-1.082,1.067-.013.723,0,1.447,0,2.2.1,0,.188.012.273.013h2.517c.547,0,.667.118.667.655q0,1.442,0,2.884c0,.45-.112.564-.563.566-.863,0-1.727,0-2.59,0h-.3v.326q0,3.824,0,7.649c0,.686-.08.765-.775.765q-1.405,0-2.81,0c-.517,0-.637-.118-.637-.629q0-3.873,0-7.746Z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebookIcon.a30b24cd1ab2cb331595b6574fc5df8c.svg";
export { ForwardRef as ReactComponent };